import React from 'react';

import { DepartmentRoute } from '../../../components/routes/DepartmentRoute';
import { ApplicationsListPage } from '../../admin/applications/ApplicationsListPage';
import { ApplicationViewPage } from '../../admin/applications/ApplicationViewPage';
import NewApplicationViewPage from '../../admin/applications_new/ApplicationViewPageContainer';

const ApplicationsLayout = ({ match }) => (
  <div>
    <DepartmentRoute exact path={`${match.url}/`} component={ApplicationsListPage} />
    <DepartmentRoute exact path={`${match.url}/view/:id`} component={ApplicationViewPage} />
    <DepartmentRoute exact path={`${match.url}/view_new/:id`} component={NewApplicationViewPage} />
  </div>
);

export default ApplicationsLayout;
